import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

const QUERY_REMOTE_CONFIG_ENTRY = gql`
  query RemoteConfigEntry($key: String!) {
    remoteConfigEntry(key: $key) {
      key
      value
    }
  }
`;

const withRemoteConfigEntry = key =>
  graphql(QUERY_REMOTE_CONFIG_ENTRY, {
    name: 'remoteConfigData',
    options: () => ({
      variables: {
        key: key
      },
      fetchPolicy: 'network-only'
    })
  });

export default withRemoteConfigEntry;
